import React from "react"
import * as Style from "./VideoSection.module.scss"
import Video from "./video"
import Button from "../UI/button/Button"
import Arrow from "../../images/arrowVs.svg"
import Stamat from "../animation/Animation"

const VideoSection = props => {
  const titleSplit = props.videoSectionData.title.split(":")

  return (
    <div className={Style.videoSection}>
      <div className={Style.bothSidesContainer}>
        {/* left side */}
        <div className={Style.leftContainer}>
          <h2>{titleSplit[0] + ":"}</h2>
          <h2>{titleSplit[1]}</h2>
          <h3>{props.videoSectionData.sub_title}</h3>
          <div className={Style.buttonContainer}>
            <div className={Style.StamatAlt}>
              <Stamat />
            </div>
            <Button style={Style.buttonOrange}>
              {props.videoSectionData.button[0].button_title}
            </Button>
            <Button style={Style.buttonWhite}>
              {props.videoSectionData.button[1].button_title}
            </Button>
          </div>
        </div>

        {/* right side */}

        <div className={Style.rightSide}>
          <Video videoContent={props.videoSectionData.video} />

          <div className={Style.priceContainer}>
            <div className={Style.leftSidePrice}>
              <h4>{props.videoSectionData.promo.promo_price}</h4>
              <div className={Style.discountCont}>
                <del>
                  <h5 className={Style.oldPrice}>
                    {props.videoSectionData.promo.actual_price}
                  </h5>
                </del>
                <h5>{props.videoSectionData.promo.discount}</h5>
              </div>
            </div>

            <h5 className={Style.timeLeft}>
              {props.videoSectionData.promo.time_left}
            </h5>
          </div>
        </div>
      </div>
      <Arrow className={Style.arrow} />
    </div>
  )
}

export default VideoSection
